import React from "react";

export const Copyright = () => {
    return(
        <>
            <div className={'copyright__container'}>
                <p className="copyright">© 2026 Все права защищены.</p>
            </div>

        </>
    )
}